import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { InternalEvent } from './internal-event'

@Injectable()
export class InternalEventSerializer {
  fromJson(json: any): InternalEvent {
    const internalEvent = {
      ...json
    }

    return internalEvent
  }

  toJson(internalEvent: InternalEvent): any {
    return {
      ...internalEvent
    }
  }
}
